import axiosClient from './axiosClient';

const lazadaApi = {
    getProductInfo: (link) => {
        const baseURL = 'lazada/product-commission';
        return axiosClient.post(baseURL, {
            link,
        });
    },
    getProductByKeyword: (keyword, sortType) => {
        const baseURL = 'lazada/get-product-by-keyword';
        return axiosClient.post(baseURL, {
            keyword,
        });
    },
    getRecommendProductList: () => {
        const baseURL = 'lazada/recommend-product-list';
        return axiosClient.get(baseURL);
    },
    getLinkAff: (itemId, skuId, offerId, source) => {
        return axiosClient.post('lazada/get-link', { itemId, skuId, offerId, ...(source && { source }) });
    },
    // Used by trending/saved pages — pass full product URL + info for affiliate link generation
    getLinkAffByUrl: (url, productInfo = {}, source) => {
        return axiosClient.post('lazada/get-link', { link: url, ...productInfo, ...(source && { source }) });
    },
    findOrder: (orderId) => {
        const baseURL = 'lazada/find_order';
        return axiosClient.post(baseURL, {
            orderId,
        });
    },
};

export default lazadaApi;
